export interface SuccessfulSaveToRecord{
  timeStamp: number;
}

export interface FailedSaveToRecord{
  statusCode: number;
}

export const SAVING = 'SAVING' as const;

export function isFailedSaveToRecord(writeToRecord: unknown): writeToRecord is FailedSaveToRecord {
  return !!(writeToRecord && (writeToRecord as FailedSaveToRecord).statusCode);
}

export function isSaving(writeToRecord: unknown): writeToRecord is typeof SAVING {
  return writeToRecord === SAVING;
}

export function isSuccessfulSaveToRecord(writeToRecord: unknown): writeToRecord is SuccessfulSaveToRecord {
  return !!(writeToRecord && (writeToRecord as SuccessfulSaveToRecord).timeStamp);
}
